import { Theme } from 'styling/theme'
import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme: Theme) => ({
    paywallContainer: {
        height: '100%',
        overflow: 'auto',
        backgroundColor: theme.colors.light.offWhite2,
        padding: '24px 12px 0 12px',

        '@media (min-width: 768px)': {
            backgroundColor: theme.colors.light.offWhite2,
            padding: '32px 16px 0 16px',
            height: '100%',
        },
    },
}))
